/* eslint-disable no-undef */

import axios from 'axios';
import config from './config';

// process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
const API = axios.create({
	//baseURL: process.env.REACT_APP_API_BACKEND_BASE_URL,
	baseURL: config.apiUrl,
});

API.interceptors.request.use((req) => {
	req.headers['Content-Type'] = 'application/json';
	//req.headers['Content-Security-Policy'] = 'upgrade-insecure-requests';
	//req.headers['Content-Security-Policy'] = 'upgrade-insecure-requests';
	// req.headers['Access-Control-Allow-Methods'] =
	// 	'GET, POST, PATCH, PUT, DELETE, OPTIONS';
	// req.headers['Access-Control-Allow-Headers'] =
	// 	'Origin, Content-Type, X-Auth-Token';
	// if(token)
	// 	req.headers.Authorization = `Bearer ${token}`;
	// if (localStorage.getItem('profile')) {
	// 	req.headers.Authorization = `Bearer ${
	// 		JSON.parse(localStorage.getItem('profile')).token
	// 	}`;
	// }

	return req;
});

/* params */
const typeParam = { Type: 'checkin' };
const cnoWithTypeParam = {
	ConfirmationNo: 318918,
	Type: 'checkin',
};

/* api call to generate token */
export const getToken = async (propertyCode) =>
	API.post('/Authentication/GenerateToken', {
		userName: process.env.REACT_APP_USERNAME,
		password: process.env.REACT_APP_PASSWORD,
		vendorCode: propertyCode,
	});

export const getPropertyInfo = async (token) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	const response = await API.get('/Master/GetPropertyInfo', {
		headers: header,
	});
	return response;
};

/* api calls for /Reservation/ path */
export const getReservation = async (token, ConfirmationNo, PropertyCode) => {
	if (PropertyCode !== null && PropertyCode !== undefined) {
		const header = {
			Authorization: `Bearer ${token}`,
		};
		// API.get('/Kiosk/GetReservationDetails?ConfirmationNo=' + ConfirmationNo, {
		// 	headers: header,
		// });
		const cnoParam = {
			ConfirmationNo: ConfirmationNo,
			PropertyCode: PropertyCode, //added new
		};
		return API.get('/Reservation/GetReservation', {
			params: cnoParam,
			headers: header,
		});
	}
};

export const getProfilesFromReservation = () =>
	API.get('/Reservation/GetReservationProfiles', cnoParam);

export const getCurrentStage = (token, type, ConfirmationNo, propertyCode) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	const param = {
		ConfirmationNo: ConfirmationNo,
		type: type,
		PropertyCode: propertyCode, //added new
	};
	return API.get('/Master/GetCurrentStep', {
		params: param,
		headers: header,
	});
};

export const updateReservationProfile = (profile) => {
	const header = {
		Authorization: `Bearer ${profile.token}`,
	};
	return API.post('/Reservation/UpdateReservationProfile', profile, {
		headers: header,
	});
};

export const updateReservationPreferences = (preferences) =>
	API.post('/Reservation/UpdateReservationPreferences', preferences);

export const GetReservationFromPMS = (token, confirmationNo) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};

	return API.get(
		'/Kiosk/GetReservationDetails?ConfirmationNo=' + confirmationNo,
		{
			headers: header,
		}
	);
};

export const GetReservationPaymentInfo = (
	token,
	confirmationNo,
	reservationNameID
) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};

	return API.get(
		'/Kiosk/GetReservationPaymentInfo?ConfirmationNo=' +
			confirmationNo +
			'&ReservationNameID=' +
			reservationNameID,
		{
			headers: header,
		}
	);
};

export const saveRegCard = (
	token,
	reservationId,
	confirmationNo,
	signature,
	propertyCode
) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	const param = {
		confirmationNo: confirmationNo,
		reservationID: reservationId,
		signatureBase64: signature,
		PropertyCode: propertyCode, //added new
		documentType: 'RegCard',
		takeFromDB: true,
	};
	return API.post('/Reservation/SaveRegistrationCard', param, {
		headers: header,
	});
};

export const getTermsAndConditions = (token) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};

	return API.get('/Reservation/GetTermsAndCondition', {
		headers: header,
	});
};

export const getGetPrivacyPolicy = (token) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};

	return API.get('/Reservation/GetPrivacyPolicy', {
		headers: header,
	});
};

/* api calls for the /master/ path */
export const getFieldList = (token) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	return API.get('/Master/GetFieldList', { headers: header });
};

export const getSettingList = (token) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	return API.get('/Reservation/GetSettingParameter', { headers: header });
};

export const adyenWebhook = (token, orderRef, redirectResult) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	return API.get(
		'/Payment/AdyenWebhook?orderRef=' +
			orderRef +
			'&redirectResult=' +
			redirectResult,
		{ headers: header }
	);
};

export const getCountries = (token) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	return API.get('/Master/GetCountries', { headers: header });
};
export const getSteps = (token, type) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	const typeParam = {
		type: type,
		IsEnabled: true,
	};
	return API.get('/Master/GetAllSteps', { params: typeParam, headers: header });
};

export const getSupportedDocuments = (token) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	const typeParam = {
		appType: 'engage',
	};
	return API.get('/Master/GetDocumentMaster', {
		params: typeParam,
		headers: header,
	});
};

export const completeStep = (token, stageID, ReservationID, confirmationNo) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	// if (stageID === 4) {
	// 	const body = {
	// 		confirmationNo: confirmationNo,
	// 		approvalCode: '',
	// 		eRegCard: '',
	// 		cardType: '',
	// 		primaryGuestNameID: '',
	// 		comments: [
	// 			{
	// 				text: '',
	// 			},
	// 		],
	// 		udfFieldName: '',
	// 		udfFieldValue: '',
	// 		udfFieldSpecified: false,
	// 		printRate: false,
	// 		rateCode: '',
	// 		rtc: '',
	// 		roomTypeCode: '',
	// 		checkoutTime: '',
	// 		checkOutTimeSpecified: false,
	// 		adultCount: 1,
	// 		adultCountSpecified: true,
	// 		childCount: 0,
	// 		childCountSpecified: false,
	// 		noPost: null,
	// 		isNoPost: null,
	// 		doNotMoveRoom: null,
	// 		reservationSourceSpecified: false,
	// 		reservationSourceCode: '',
	// 		preRegisterFlag: true,
	// 		preRegisterFlagSpecified: true,
	// 		reservationNameID: '',
	// 	};
	// 	API.post(`/Kiosk/ModifyReservationBooking`, body, {
	// 		headers: header,
	// 	})
	// 		.then((response) => {
	// 			// Handle success response here
	// 			console.log('Response:', response.data);
	// 			if (error.response) {
	// 				// The request was made, but the server responded with an error status code
	// 				console.error('Response data:', error.response.data);
	// 				console.error('Response status:', error.response.status);
	// 			} else if (error.request) {
	// 				// The request was made, but there was no response from the server
	// 				console.error('No response received');
	// 			} else {
	// 				// Something happened in setting up the request that triggered an error
	// 				console.error('Error:', error.message);
	// 			}
	// 		})
	// 		.catch((error) => {
	// 			// Handle the AxiosError
	// 			if (error.response) {
	// 				// The request was made, but the server responded with an error status code
	// 				console.error('Response data:', error.response.data);
	// 				console.error('Response status:', error.response.status);
	// 			} else if (error.request) {
	// 				// The request was made, but there was no response from the server
	// 				console.error('No response received');
	// 			} else {
	// 				// Something happened in setting up the request that triggered an error
	// 				console.error('Error:', error.message);
	// 			}
	// 		});
	// }

	return API.get('/Master/CompleteStage', {
		params: {
			StepID: stageID,
			ReservationID: ReservationID,
		},
		headers: header,
	});
};

// export const modifyReservationBooking = (token) => {
// 	const header = {
// 		Authorization: `Bearer ${token}`,
// 	};

// 	const body = {
// 		PreRegisterFlag: true,
// 		PreRegisterFlagSpecified: true,
// 	};
// 	return API.post(`/Kiosk/ModifyReservationBooking`, body, {
// 		headers: header,
// 	});
// };
export const skipStep = (token, stageID, ReservationID) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	return API.get('/Master/SkipStage', {
		params: {
			StepID: stageID,
			ReservationID: ReservationID,
		},
		headers: header,
	});
};
export const getReservationProfiles = (token, ConfirmationNo) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	return API.get('/Reservation/GetReservationProfiles', {
		params: {
			ConfirmationNo: ConfirmationNo,
		},
		headers: header,
	});
};
export const updateGuestProfile = (profile) => {
	const header = {
		Authorization: `Bearer ${profile.token}`,
	};
	// const body = {
	// 	reservationID: profile.reservationID,
	// 	profileID: profile.profileID,
	// 	transactionGUID: profile.transactionGUID,
	// 	pmsConfirmationNo: profile.pmsConfirmationNo,
	// 	firstName: profile.firstName,
	// 	countryOfResidence: profile.countryOfResidence,
	// 	city: profile.city,
	// 	email: profile.email,
	// 	lastName: profile.lastName,
	// 	phoneNo_Res: profile.phoneNo_Res,
	// 	addressLine1: profile.addressLine1,
	// 	isPrimary: true,
	// 	pmsProfileID: profile.pmsProfileID,
	// 	propertyCode: profile.propertyCode,
	// 	vehiclePlateNo: profile.vehiclePlateNo,
	// 	postalCode: profile.postalCode,
	// 	permitNo: profile.permitNo,
	// 	euPlaceOfEntry: profile.euPlaceOfEntry,
	// 	euDateOfEntry: profile.euDateOfEntry,
	// 	maidenName: profile.maidenName,
	// 	dateofBirthDT: profile.dateofBirthDT,
	// 	issuePlace: profile.issuePlace,
	// 	profileDocuments: [],
	// 	udfFields: profile.udfFields,
	// };
	return API.post(
		`/Document/UpdateProfilDetails${
			profile.transactionGUID
				? '?TransactionGuid=' + profile.transactionGUID
				: ''
		}`,
		profile,
		{
			headers: header,
		}
	);
};

/* api calls for the /Document/ path */
export const verifyFace = (token, image, transactionGUID) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	const param = {
		model: {
			code: 0,
			images: [image],
		},
		guid: transactionGUID,
	};
	return API.post('Document/VerifyFaceImage', param, { headers: header });
};

export const processDocument = async (
	token,
	profileID,
	pmsConfirmationNo,
	docufront,
	docuback,
	isPassport,
	propertyCode
) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	var param = {
		profileID: profileID,
		pmsConfirmationNo: pmsConfirmationNo,
		documentBase64Image: '',
		isFrontIDAdded: false,
		isBackIDAdded: false,
		isPassportAdded: isPassport,
		propertyCode: propertyCode,
	};

	let response;
	try {
		if (isPassport) {
			let finalParam = [];
			param['isPassportAdded'] = true;
			param['documentBase64Image'] = docufront;
			finalParam.push(param);
			response = await API.post('/Document/ProcessDocuments', finalParam, {
				headers: header,
			});
		} else {
			var finalParam = [];

			var param1 = {
				profileID: profileID,
				pmsConfirmationNo: pmsConfirmationNo,
				documentBase64Image: docufront,
				isFrontIDAdded: true,
				isBackIDAdded: true,
				isPassportAdded: false,
				propertyCode: propertyCode,
			};
			finalParam.push(param1);

			var param2 = {
				profileID: profileID,
				pmsConfirmationNo: pmsConfirmationNo,
				documentBase64Image: docuback,
				isFrontIDAdded: true,
				isBackIDAdded: true,
				isPassportAdded: false,
				propertyCode: propertyCode,
			};
			finalParam.push(param2);

			// param['isFrontIDAdded'] = true;
			// param['documentBase64Image'] = docufront;
			// param['isBackIDAdded'] = true;
			// finalParam.push(param);
			// param['documentBase64Image'] = '';
			// finalParam.push(param);

			response = await API.post('/Document/ProcessDocuments', finalParam, {
				headers: header,
			});
		}
	} catch (error) {
		//console.error(error);
		return error.response;
	}
	return response;
};

export const getPaymentMethods = async (token) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};

	const response = await API.get('/Payment/GetPaymentMethods', {
		headers: header,
	});

	return response?.data?.data?.paymethodDetails;
};

// Event handlers called when the shopper selects the pay button,
// or when additional information is required to complete the payment
export const handleAdyenSubmission = async (
	token,
	body,
	url,
	pmsConfirmationNo
) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};

	const typeParam = {
		PMSConfirmationNo: pmsConfirmationNo,
	};

	try {
		const res = await API.post(url, body, {
			params: typeParam,
			headers: header,
		});
		return res;
	} catch (error) {
		console.error(error);
		toast.error('Error occurred. Look at console for details');
	}
};

export const SaveTermsAndCondition = (
	token,
	reservationId,
	confirmationNo,
	tnChecked,
	propertyCode
) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	const param = {
		confirmationNo: confirmationNo,
		reservationID: reservationId,
		tnChecked: tnChecked,
		PropertyCode: propertyCode, //added new
	};
	//return true;

	return API.post('/Reservation/SaveTermsAndCondition', param, {
		headers: header,
	});
};
export const getMultiTexts = (token, languageCode) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	return API.get('/Master/GetMultiLanguageText?language=' + languageCode, {
		headers: header,
	});
};

export const fetchPaymentPayload = (
	token,
	confirmationNo,
	reservationNameId,
	amount
) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};
	return API.get(
		'/PosPayment/FetchPaymentPayload?ConfirmationNo=' +
			confirmationNo +
			'&ReservationNameID=' +
			reservationNameId +
			'&Amount=' +
			amount,
		{
			headers: header,
		}
	);
};
export const SaveTransaction = (token, transaction) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};

	return API.post('/PosPayment/PostTransaction', transaction, {
		headers: header,
	});
};

export const StripeCreatePaymentIntent = (token, transaction) => {
	const header = {
		Authorization: `Bearer ${token}`,
	};

	return API.post('/Payment/StripeCreatePaymentIntent', transaction, {
		headers: header,
	});
};
